/** Lowercase hex SHA-256 of the bytes (Web Crypto). Blobs are content-addressed by this. */
export async function sha256Hex(data: ArrayBuffer | Uint8Array | Blob): Promise<string> {
  const buf = data instanceof Blob ? await data.arrayBuffer() : data instanceof Uint8Array ? toArrayBuffer(data) : data;
  const digest = await crypto.subtle.digest('SHA-256', buf);
  return hex(new Uint8Array(digest));
}

export function hex(bytes: Uint8Array): string {
  let s = '';
  for (const b of bytes) s += b.toString(16).padStart(2, '0');
  return s;
}

export function toArrayBuffer(u: Uint8Array): ArrayBuffer {
  if (u.byteOffset === 0 && u.byteLength === u.buffer.byteLength && u.buffer instanceof ArrayBuffer) return u.buffer;
  return u.slice().buffer as ArrayBuffer;
}

export const SHA256_RE = /^[0-9a-f]{64}$/;
